import { useBakingTimer } from '../../../hooks/useBakingTimer';
import ProgressBar from '../../ui/ProgressBar';

function InlineTimer({ order }) {
  const timer = useBakingTimer(order);

  if (order.state !== 'baking') return null;

  return (
    <div className={`rounded-md border px-3 py-2 ${
      timer.overtime
        ? 'border-red-500/40 bg-red-500/5 text-red-400'
        : 'border-orange-500/40 bg-orange-500/5 theme-accent-warm'
    }`}>
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-medium">{timer.label}</span>
        <span className="text-xs opacity-60">{Math.round(timer.progress * 100)}%</span>
      </div>
      <ProgressBar progress={timer.progress} overtime={timer.overtime} className="mt-1.5" />
    </div>
  );
}

export default InlineTimer;